import React, {useState, useEffect} from 'react'
import {Form, Input, Row, Col, Button, message} from 'antd'
import API from 'api'
import {useSelector} from 'react-redux'
import {IState} from 'reducers'
import {useHistory} from 'react-router-dom'

const passwordRules = [
  {
    required: true,
    message: '密码为数字，字母，下划线',
    pattern: /^[0-9a-zA-Z_]{8,}$/,
  },
]

const confirmPasswordRules = [
  ({getFieldValue}) => ({
    validator(_, value) {
      if (!value || getFieldValue('new_password') === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('请输入相同的密码'))
    },
  }),
]

const phoneRules = [
  {
    required: true,
    message: '请输入正确的手机号码',
    pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
  },
]

const captchaRules = [
  {
    required: true,
    message: '请输入正确的验证码',
    pattern: /^\d{6}$/,
  },
]
const PhoneFormCom = () => {
  const [editPwdWithPhoneForm] = Form.useForm()
  const [sendingCaptcha, setSendingCaptcha] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [countDown, setCountDown] = useState(60)
  const user = useSelector((state: IState) => state.user)
  const history = useHistory()

  useEffect(() => {
    var cInterval
    if (sendingCaptcha) {
      cInterval = setInterval(() => {
        setCountDown(countDown - 1)
      }, 1000)
    }

    if (countDown === 0) {
      clearInterval(cInterval)
      setSendingCaptcha(false)
      let pattern = /^1[3|4|5|7|8|9][0-9]\d{8}$/
      if (pattern.test(editPwdWithPhoneForm.getFieldValue('phone'))) {
        setDisabled(false)
      } else {
        setDisabled(true)
      }
    }
    return () => {
      clearInterval(cInterval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendingCaptcha, countDown])

  const editPassword = values => {
    values.user_id = user.user_id
    delete values.queryPassword
    API.editPassword(values).then(res => {
      switch (res.code) {
        case 200:
          message.success({
            content: '修改密码成功',
            duration: 2,
          })
          history.push('/user/info')
          break
        case 400:
          message.error({
            content: '验证码输入错误',
            duration: 2,
          })
          break
        case 1007:
          message.error({
            content: '请输入正确的手机号',
            duration: 2,
          })
          break
      }
    })
  }

  const cancelEditPassword = () => {
    history.push('/user/info')
  }

  const handlePhoneChange = (changedValues, allValues) => {
    let pattern = /^1[3|4|5|7|8|9][0-9]\d{8}$/
    if (!sendingCaptcha && pattern.test(allValues.phone)) {
      setDisabled(false)
    } else if (sendingCaptcha || !pattern.test(allValues.phone)) {
      setDisabled(true)
    }
  }

  const handleClickCaptcha = () => {
    API.SendSms(editPwdWithPhoneForm.getFieldValue('phone'), 'new').then(res => {
      if (res.code === 200) {
        setCountDown(60)
        setSendingCaptcha(true)
        setDisabled(true)
        message.success({
          content: '发送验证码成功，请注意查收',
          duration: 2,
        })
      } else if (res.code === 400) {
        message.error({
          content: '输入手机号不正确，请重新输入',
          duration: 2,
        })
      }
    })
  }

  return (
    <>
      <div className="user-info-wrap">
        <div className="second-title" style={{color: '#262626', marginBottom: 16}}>
          修改密码
        </div>
        <Form
          form={editPwdWithPhoneForm}
          onFinish={editPassword}
          requiredMark={false}
          colon={false}
          labelAlign="left"
          onValuesChange={handlePhoneChange}
        >
          <Form.Item
            name="phone"
            rules={phoneRules}
            label="手机号"
            className="user-password-form-item"
          >
            <Input
              size="large"
              placeholder="请输入绑定的手机号"
              className="user-password-form-item-input"
              maxLength={11}
            />
          </Form.Item>
          <Form.Item style={{width: 416, marginBottom: 0}}>
            <Row>
              <Col span={20}>
                <Form.Item
                  label="验证码"
                  name="captcha"
                  rules={captchaRules}
                  className="user-password-form-item"
                >
                  <Input
                    size="large"
                    placeholder="请输入手机验证码"
                    className="user-password-form-item-input"
                    style={{width: 222}}
                    maxLength={6}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Button
                  size="large"
                  className="login-captcha-button"
                  onClick={handleClickCaptcha}
                  disabled={disabled}
                >
                  {sendingCaptcha ? countDown + 's' : '获取验证码'}
                </Button>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item
            label="新密码"
            name="new_password"
            rules={passwordRules}
            className="user-password-form-item"
          >
            <Input.Password
              size="large"
              placeholder="请输入至少8位密码"
              className="user-password-form-item-input"
            />
          </Form.Item>
          <Form.Item
            label="确认密码"
            name="queryPassword"
            rules={confirmPasswordRules}
            dependencies={['new_password']}
            className="user-password-form-item"
          >
            <Input.Password
              size="large"
              placeholder="请输入至少8位密码"
              className="user-password-form-item-input"
            />
          </Form.Item>
          <Form.Item>
            <div className="user-password-form-item-button-outer">
              <Button
                size="large"
                className="user-password-form-item-button"
                onClick={cancelEditPassword}
              >
                取消
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="user-password-form-item-button"
              >
                提交
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  )
}

export default PhoneFormCom
